<template>
    <div @click="resetSessionTimeout" @keydown="resetSessionTimeout">
        <div
            v-if="selectedTestCase"
            style="position: absolute; top: 0; right: 10px; color: #000; z-index: 1000; font-size: 1.1rem; cursor: pointer"
        >
            <span :class="{ transparent: !testCaseVisible }" @click="toggleTestCaseVisibility">
                {{selectedTestCase.name }}
            </span>
        </div>

        <v-app :class="{'session-valid': sessionValid}">
            <NavBar />
            <v-main>
                <Stepper v-if="showStepper" />
                <div class="wrapper">
                    <router-view></router-view>
                    <Footer />
                </div>
            </v-main>
            <SmallScreenNag v-if="atHome"/>
        </v-app>
        <SessionTimeoutModal :show-modal="showSessionTimeoutModal" />
    </div>
</template>

<script>
    import NavBar from "@/components/layout/NavBar"
    import Footer from "@/components/layout/Footer"
    import { sessionService } from "@/service"
    import SessionTimeoutModal from "@/components/modal/SessionTimeoutModal"
    import CancelApplicationModal from "@/components/modal/CancelApplicationModal"
    import { mapState } from "vuex"
    import debounce from "lodash/debounce"
    import Modal from "@/components/modal/Modal"
    import SmallScreenNag from "@/components/modal/SmallScreenNag"


    export default {
        name: "App",
        components: {
            SmallScreenNag,
            Modal,
            CancelApplicationModal,
            SessionTimeoutModal,
            NavBar,
            Footer,
        },

        data() {
            return {
                showSessionTimeoutModal: false,
                showCancelModal: false,
                testCaseVisible: true,
            }
        },

        mounted() {
            sessionService.addEventListener("showSessionTimeoutModal", () => {
                if (!this.showSessionTimeoutModal) {
                    this.showSessionTimeoutModal = true
                    this.showCancelModal = false
                }
            })

            sessionService.addEventListener("resetTimeout", () => {
                if (this.showSessionTimeoutModal) {
                    this.showSessionTimeoutModal = false
                }
            })
        },

        computed: {

            ...mapState("session", {
                atHome: state => state.data.experienceType === 'at_home',
                sessionValid: state => !!state.data.dynamicProviderKey?.providerKey,
            }),

            showStepper() {
                return this.$route.meta?.stepper !== false
            },

            ...mapState("testCase", {
                selectedTestCase: state => state.selectedTestCase,
            }),
        },

        methods: {
            resetSessionTimeout: debounce(function() {
                sessionService.resetSessionTimeout()
            }, 500),

            toggleTestCaseVisibility() {
                this.testCaseVisible = !this.testCaseVisible
            },
        },
    }
</script>

<style lang="scss" scoped>
    body {
        font-size: rem(16);
        line-height: rem(24);
        color: #434a4f;
    }

    .wrapper {
        margin: auto;

        @media #{map-get($display-breakpoints, "sm-and-up")} {
            max-width: 97%;
        }
    }

    .fix-bottom {
        position: fixed;
        bottom: 10px;
    }

    .v-main {
        padding-bottom: 64px;
    }
</style>
